import { Directive, Input } from "@angular/core";


interface Chart {
   createChart() : void;
}


@Directive()
export abstract class ChartJSWidgetComponent implements Chart {

   @Input()
	public active: boolean;

   @Input()
   public type: string;

   @Input()
   public label : string;

   abstract createChart() : void
}